/*
 * @Description:
 * @Author: mdb
 * @Date: 2022-05-23 16:48:06
 * @LastEditTime: 2022-08-18 09:29:05
 * @LastEditors: mdb
 */
import './dc_init'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue'
import { createPinia } from 'pinia'
import { bridge } from '@dc-platform/dc-bridge'
import DcComponents from '@dc-platform/dc-components'
import '@dc-platform/dc-components/dist/style.css'
import '@dc-platform/dc-icons/iconfont.css' // 导入图标库
import CosTable from '@/components/CosTable'
import CosApiSelect from '@/components/CosApiSelect'
import CosModal from '@/components/CosModal'

import MoreButton from '@/components/MoreButton'
import CosCascader from '@/components/CosCascader/index.vue'
import CosRangePicker from '@/components/CosRangePicker'
import CosStaticSelect from '@/components/CosStaticSelect'
import CosFooterButton from '@/components/CosFooterButton/index'
import ParamCodesSelect from '@/components/ParamCodesSelect'
import ExportButton from '@/components/ExportBtn'
import SellerButton from '@/components/SellerButton'
import UserSelect from '@/components/UserSelect/index'
import CosLayoutMain from '@/components/CosLayoutMain/index.vue'
import CosViewContent from '@/components/CosViewContent/index.vue'

// 自定义ant输入类型的组件
import CosInput from '@/components/Antd/CosInput/index.vue'
import CosSelect from '@/components/Antd/CosSelect/index.vue'
import CosTextarea from '@/components/Antd/CosTextarea/index.vue'
import CosInputNumber from '@/components/Antd/CosInputNumber/index.vue'
import CosRadioGroup from '@/components/Antd/CosRadioGroup/index.vue'

import i18n from '@/lang'
import '@/styles/index.scss'
import directives from '@/directives/index' // 自定义指令
let instance: any = null
const renderApp = () => {
  const app = createApp(App)
  app.use(createPinia())
  app.use(router)
  app.use(Antd)
  app.use(DcComponents)
  app.use(i18n)
  app.use(directives)
  app.component('CosTable', CosTable)
  app.component('CosApiSelect', CosApiSelect)
  app.component('CosModal', CosModal)
  app.component('CosInput', CosInput)
  app.component('CosSelect', CosSelect)
  app.component('CosRadioGroup', CosRadioGroup)
  app.component('CosTextarea', CosTextarea)
  app.component('CosInputNumber', CosInputNumber)
  app.component('CosViewContent', CosViewContent)

  app.component('MoreButton', MoreButton)
  app.component('CosCascader', CosCascader)
  app.component('CosRangePicker', CosRangePicker)
  app.component('CosFooterButton', CosFooterButton)
  app.component('ParamCodesSelect', ParamCodesSelect)
  app.component('ExportButton', ExportButton)
  app.component('UserSelect', UserSelect)
  app.component('SellerButton', SellerButton)
  app.component('CosStaticSelect', CosStaticSelect)
  app.component('CosLayoutMain', CosLayoutMain)
  app.mount('#app')
  return app
}
// 引入折线图/柱状图等组件,折线图是line,饼图改为pie,柱形图改为bar
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/funnel')

// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/grid')
require('echarts/lib/component/toolbox')
// 如果是独立打开， 则直接进行渲染
if (!bridge.isInDcEnvironment()) {
  renderApp()
}

let count = 0
export async function bootstrap() {
  console.log('dc-cos bootstrap', count)
}
export async function mount() {
  instance = renderApp()
}
export async function unmount() {
  console.log('dc-cos unmount', count)
  instance.unmount()
  instance = null
  ++count
}
